import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c3ffb04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "JobBoardList" }
const _hoisted_2 = {
  class: "JobBoardList__Summary__Top",
  ref: "stickyTop"
}
const _hoisted_3 = { class: "JobBoardList__Summary__Inner JobBoardList__Summary__Inner--Default" }
const _hoisted_4 = { class: "JobBoardList__Summary__Results" }
const _hoisted_5 = { class: "JobBoardList__Summary__Inner JobBoardList__Summary__Inner--Sticked" }
const _hoisted_6 = { class: "JobBoardList__Summary__Text" }
const _hoisted_7 = { class: "JobBoardList__Summary__Label" }
const _hoisted_8 = { class: "JobBoardList__Summary__Search" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, null, -1))
const _hoisted_10 = { class: "JobBoardList__Summary__Results" }
const _hoisted_11 = { class: "JobBoardList__Items" }
const _hoisted_12 = { ref: "list" }
const _hoisted_13 = ["data-index"]
const _hoisted_14 = { class: "JobBoardList" }
const _hoisted_15 = { class: "JobBoardList__LoadMore" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JobBoardCard = _resolveComponent("JobBoardCard")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    _createElementVNode("header", {
      class: _normalizeClass(["JobBoardList__Summary", { 'is-sticked': _ctx.isMobileSticked && _ctx.Viewport.isMobile, 'has-header-offset': _ctx.hasMobileHeaderDeployed }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString((_ctx.jobPage?.count === 1) ? _ctx.$t('jobBoard.result', {nb: _ctx.jobPage?.count}) : _ctx.$t('jobBoard.results', {nb: _ctx.jobPage?.count})), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('jobBoard.search')) + " ", 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.searchText ? _ctx.searchText : _ctx.$t('jobBoard.everywhere')), 1)
        ]),
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString((_ctx.jobPage?.count === 1) ? _ctx.$t('jobBoard.result', {nb: _ctx.jobPage?.count}) : _ctx.$t('jobBoard.results', {nb: _ctx.jobPage?.count})), 1)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_TransitionGroup, {
          name: "card",
          tag: "ul",
          onBeforeEnter: _ctx.onBeforeEnter,
          onEnter: _ctx.onEnter,
          onBeforeLeave: _ctx.onBeforeLeave,
          onLeave: _ctx.onLeave
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobPage.jobs, (job, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: 'job-board-card-' + job.slug,
                "data-index": index
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_JobBoardCard, { job: job }, null, 8, ["job"])
                ])
              ], 8, _hoisted_13))
            }), 128))
          ]),
          _: 1
        }, 8, ["onBeforeEnter", "onEnter", "onBeforeLeave", "onLeave"])
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.hasMore)
        ? (_openBlock(), _createBlock(_component_ButtonHover, {
            key: 0,
            class: _normalizeClass(["button button--black", {'active': _ctx.hasMore}]),
            type: "button",
            onClick: _ctx.showMore
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('jobBoard.loadMore')), 1)
            ]),
            _: 1
          }, 8, ["class", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}